import workDays from "./workdays";
import moment from "moment";

export default {
  name: "CampaignAddRecord",

  props: {
    projectUuid: {
      type: String,
      default: ""
    },
    campaignUuid: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      helpDeskNumbers: [],
      addRecordModel: "single",
      form: {
        campaignType: "",
        adescomNumber: "",
        workDays: [],
        timeStop: null,
        timeStart: null,
        pauseTimeMin: 3,
        countTry: 3,
        sleepTime: 1,
        stamp: "",
        number: "",
        validatedRecordsFromFile: []
      },
      fileContent: "",
      submitted: false,
      allRecordsFromFile: [],
      isFileUploading: false,
      gridData: [
        {
          content:
            "Jeśli pominiesz datę lub w jej miejscu wpiszesz 0, rekord zostanie dodany z obecną datą"
        },
        {
          content: "111222333,2022-06-15 15:00,treść-notatki"
        },
        {
          content: "111222333,0"
        },
        {
          content: "111222333,treść-notatki"
        },
        {
          content: "111222333"
        }
      ],
      allWorkDays: workDays.workDays,
      rules: {
        campaignType: [{ required: true, message: "Typ jest wymagany.", trigger: "blur" }],
        number: [
          { required: true, message: "Numer jest wymagany.", trigger: "blur" },
          { validator: this.__validateNumber, trigger: "blur" }
        ],
        adescomNumber: [
          { required: true, message: "Numer prezentacji jest wymagany.", trigger: "blur" }
        ],
        countTry: [
          { required: true, message: "Ilość prób jest wymagana.", trigger: "blur" },
          { validator: this.__validateCountTry, trigger: "blur" }
        ],
        pauseTimeMin: [
          { required: true, message: "Czas między próbami jest wymagany.", trigger: "blur" }
        ],
        validatedRecordsFromFile: [
          { type: "array", required: true, message: "Plik jest wymagany.", trigger: "blur" },
          { validator: this.__checkRecordsCount, trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    fileContent: {
      handler: "readFile",
      immediate: false
    }
  },
  computed: {
    statusAndRecordDictionary() {
      return this.$store.getters["campaign/statusAndRecordDictionary"];
    },
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "client/project/getHelpdeskNumbersForProject",
        "campaign/getAllStatusAndRecordDictionary"
      ]);
    }
  },
  async created() {
    this.$store.dispatch("campaign/getAllStatusAndRecordDictionary", {
      projectUuid: this.projectUuid,
      dialoutUuid: this.campaignUuid
    });
    this.helpDeskNumbers = await this.$store.dispatch(
      "client/project/getHelpdeskNumbersForProject",
      this.projectUuid
    );
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    readFile() {
      if (this.fileContent) {
        this.allRecordsFromFile = this.fileContent.split("\n");
        this.form.validatedRecordsFromFile = [];
        // eslint-disable-next-line no-restricted-globals
        this.allRecordsFromFile.forEach(elem => {
          let singleRecord = elem.split(",");
          let number = singleRecord[0].trim();
          let note = "";
          let date = "0";
          if (
            singleRecord?.length > 1 &&
            (!moment(singleRecord[1].trim()).isValid() &&
              singleRecord[1].trim() !== "0" &&
              singleRecord[1].trim() !== "")
          ) {
            note = singleRecord[1].trim();
          } else if (
            singleRecord?.length > 1 &&
            (moment(singleRecord[1].trim()).isValid() ||
              singleRecord[1].trim() === "0" ||
              singleRecord[1].trim() === "")
          ) {
            date = singleRecord[1].trim() === "" ? "0" : singleRecord[1].trim();
            note = singleRecord[2] ? singleRecord[2].trim() : "";
          }
          let timestamp = moment(date);
          if (
            !isNaN(number) &&
            (number.length === 9 || number.length === 11) &&
            (timestamp.isValid() || date === "0")
          ) {
            if (number.length === 9) number = `48${number}`;
            this.form.validatedRecordsFromFile.push({
              number: number,
              timestamp: date === "0" ? "" : timestamp.format("YYYY-MM-DD HH:mm:ss"),
              note: note
            });
            this.form.loadedFile = true;
          }
        });
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createInput(files[0]);
    },
    createInput(file) {
      const reader = new FileReader();
      let vm = this;
      reader.onload = () => {
        vm.fileContent = reader.result;
      };
      reader.readAsText(file);
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.addRecordModel === "single") {
            const params = {
              campaign_type_uuid: this.form.campaignType,
              adescom_num: this.form.adescomNumber,
              workday: this.form.workDays,
              time_stop: this.form.timeStop,
              time_start: this.form.timeStart,
              pause_time_min: this.form.pauseTimeMin,
              count_try: this.form.countTry,
              sleep_time: this.form.sleepTime,
              stamp: this.form.stamp ? this.form.stamp : moment().format("YYYY-MM-DD HH:mm:ss"),
              num_for_call:
                this.form.number.length === 9 ? `48${this.form.number}` : this.form.number,
              project_uuid: this.projectUuid,
              campaign_uuid: this.campaignUuid
            };
            const responseStatus = await this.$store.dispatch("campaign/addRecordToList", params);
            if (responseStatus === 200) {
              this.$message({
                type: "success",
                message: "Rekord został dodany do listy."
              });
            } else {
              this.$message({
                type: "error",
                message: "Wystąpił błąd podczas dodawania rekordu."
              });
            }
          } else {
            this.submitted = true;
            if (this.form.validatedRecordsFromFile.length > 0) {
              this.isFileUploading = true;
              const params = {
                campaign_type_uuid: this.form.campaignType,
                adescom_num: this.form.adescomNumber,
                workday: this.form.workDays,
                time_stop: this.form.timeStop,
                time_start: this.form.timeStart,
                pause_time_min: this.form.pauseTimeMin,
                count_try: this.form.countTry,
                sleep_time: this.form.sleepTime,
                records_from_file: this.form.validatedRecordsFromFile,
                project_uuid: this.projectUuid,
                campaign_uuid: this.campaignUuid
              };
              const responseStatus = await this.$store.dispatch(
                "campaign/addMultipleRecordsToList",
                params
              );
              if (responseStatus === 200) {
                this.$message({
                  type: "success",
                  message: "Rekordy zostały dodane do listy."
                });
              } else {
                this.$message({
                  type: "error",
                  message: "Wystąpił błąd podczas dodawania rekordów."
                });
              }
              this.isFileUploading = false;
            }
            this.submitted = false;
          }
        }
      });
    },
    clearForm(form) {
      this.$refs.form.resetFields();
      this.form.validatedRecordsFromFile = [];
      this.allRecordsFromFile = [];
      this.fileContent = "";
    },
    __validateNumber(rule, value, callback) {
      if (value.length !== 9 && value.length !== 11) {
        callback(new Error("Numer telefonu musi mieć 9 lub 11 znaków."));
      } else {
        callback();
      }
    },
    __validateCountTry(rule, value, callback) {
      if (value < 1 || value > 9) {
        callback(new Error("Tylko wartości od 1 do 9"));
      } else {
        callback();
      }
    },
    __checkRecordsCount(rule, value, callback) {
      if (value.length > 1000) {
        callback(new Error("Maksymalnie 1000 rekordów."));
      } else {
        callback();
      }
    }
  }
};
